// import { AnalyticsService } from '@shared/services/analytics.service';
import { Component, OnInit } from '@angular/core';
// import { AnalyticsEventsMap } from '@shared/utils/constants/analytics-events';
// import { ThemeService } from '@shared/services/theme.service';

@Component({
  selector: 'obc-redirecionamento',
  templateUrl: './redirecionamento.component.html',
  styleUrls: ['./redirecionamento.component.scss'],
})
export class RedirecionamentoComponent implements OnInit {
  origemCanal: boolean;
  redirectUrl: string;
  payments: boolean;

  constructor(
    // private analyticsService: AnalyticsService,
    // private themeService: ThemeService
    ) { }

  ngOnInit() {
    const queryParamsIndex = window.location.href.indexOf('?');

    let canal: string;

    if (queryParamsIndex >= 0) {
      try {
        canal = window.location.href.substring(queryParamsIndex + 1).split('&').find(param => param.includes('canal')).split('=')[1];
      } catch {

      }
    }

    this.origemCanal = history === null
      || history.state === null
      || history.state.redirectUri === null
      || history.state.redirectUri === undefined;
    this.redirectUrl = this.origemCanal ?
      (canal !== null && canal !== undefined ? ('https://www.safra.com.br/' + canal.toLowerCase() + '/store_redirect')
         : 'https://www.safra.com.br')
       : history.state.redirectUri;
    this.payments = this.origemCanal || history.state.payments;
    this.irOutraInstituicao();
  }

  irOutraInstituicao() {
    // this.analyticsService.eventLog(AnalyticsEventsMap.TRANSMISSORA.VOLTAR_TRANSMISSORA);
    setTimeout(() => window.location.href = this.redirectUrl, this.origemCanal ? 10000 : 5000);
  }
}